import React from 'react';
import { DownloadSimple } from '@phosphor-icons/react';
import { authFetch } from '../context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ExportButtons() {
  const download = async (endpoint, filename) => {
    try {
      const res = await authFetch(`${API}${endpoint}`);
      if (!res.ok) return;
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = filename; a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) { console.error('Download failed:', err); }
  };

  return (
    <div className="flex gap-1.5 sm:gap-2" data-testid="export-buttons">
      <button data-testid="export-users-btn" onClick={() => download('/api/export/users', 'trustframe_users.csv')}
        className="inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1 sm:py-1.5 border border-tf-primary text-tf-primary font-mono text-[8px] sm:text-[9px] tracking-[0.1em] sm:tracking-[0.15em] uppercase hover:bg-tf-primary hover:text-white transition-all duration-300">
        <DownloadSimple size={10} weight="bold" /> <span className="hidden xs:inline">Users</span>
      </button>
      <button data-testid="export-txns-btn" onClick={() => download('/api/export/transactions', 'trustframe_transactions.csv')}
        className="inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1 sm:py-1.5 border border-tf-primary text-tf-primary font-mono text-[8px] sm:text-[9px] tracking-[0.1em] sm:tracking-[0.15em] uppercase hover:bg-tf-primary hover:text-white transition-all duration-300">
        <DownloadSimple size={10} weight="bold" /> <span className="hidden xs:inline">Txns</span>
      </button>
    </div>
  );
}
